import { getUsersNames } from '@/rest/users'
import getLocalizedName from '@/utils/getLocalizedName'
import i18n from '@/lang'
import store from '@/store/index.js'

export default {
  state: () => ({
    names: {}
  }),
  getters: {
    userById: state => id => {
      if (!id) {
        return 'NULL'
      }

      if (id === -1) {
        return i18n.global.t('common.system')
      }

      if (!Object.hasOwn(state.names, id)) {
        store.dispatch('loadUserNames', [id])
      }

      return getLocalizedName(state.names[id])
    }
  },
  mutations: {
    updateUsersNames (state, payload) {
      for (const key of Object.keys(payload)) {
        state.names[key] = payload[key]
      }
    },
    clearUserNames (state) {
      state.names = {}
    }
  },
  actions: {
    async loadUserNames ({ commit, state }, ids) {
      if (ids.length) {
        const missingIds = ids.filter(id => !(id in state.names))

        if (missingIds.length) {
          commit('updateUsersNames', await getUsersNames(missingIds))
        }
      }
    },
    initialize ({ commit, rootGetters }) {
      if (!rootGetters.isAuthorized) {
        return
      }

      commit('clearUserNames')
      import.meta.env.DEV && console.log('initialized store – users')
    }
  }
}
